import { APV_BASE_URL } from '../../core/shell/shell-routes.constant';

const FLOW_URL = `${APV_BASE_URL}/suscripcion`;

export const SUBSCRIPTION_URLS = {
  amount: `${FLOW_URL}/paso/1`,
  regimeFund: `${FLOW_URL}/paso/2`,
  employer: `${FLOW_URL}/paso/3`,
  addEmployer: `${FLOW_URL}/paso-agregar-empleador/3`,
  confirm: `${FLOW_URL}/paso/4`,
  success: `${APV_BASE_URL}/success`,
  failed: `${APV_BASE_URL}/failed-subscription`,
  serviceError: `${APV_BASE_URL}/service-error`,
  apvHome: `${APV_BASE_URL}/home`,
  accountDetail: APV_BASE_URL,
} as const;
